import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import { Field, reduxForm } from 'redux-form';

import FormField from '../form-field';
import '../../css/withdraw-from-purchase.css';

class WithdrawFromPurchase extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.props.onSubmit.bind(this);
  }

  renderRemoveField() {
    if (this.props.isOrganizer) {
      return undefined;
    }

    return (
      <div className="mt-4 mb-2">
        <Field
          className="mr-2"
          type="checkbox"
          name="remove"
          label={
            <FormattedMessage
              id="withdraw.removeField.label"
              defaultMessage="I don't want to receive any more updates about this group."
            />
          }
          component={FormField}
        />
      </div>
    );
  }

  render() {
    const { handleSubmit, submitting } = this.props;

    return (
      <div className="withdraw-from-purchase">
        <div className="modal-section modal-title blue full">
          <h1>
            <FormattedMessage
              id="withdraw.title"
              defaultMessage="Withdraw from group"
            />
          </h1>
        </div>
        <form className="withdraw-form" onSubmit={handleSubmit(this.onSubmit)}>
          <div className="modal-section divider">
            <p className="mb-2">
              <FormattedMessage
                id="withdraw.warning"
                defaultMessage="If you withdraw, you will not be charged for any
                  contributions you agreed to make and will no longer be considered
                  part of the group"
              />
              <br />
              <span className="light">
                <FormattedMessage
                  id="withdraw.canRejoin"
                  defaultMessage="You can join back later if there's room and time left"
                />
              </span>
            </p>
            {this.renderRemoveField()}
          </div>
          <div className="row mt-3">
            <div className="offset-2 col-5">
              <button
                type="button"
                className="btn btn-secondary"
                onClick={this.props.onStayInGroup}
              >
                <FormattedMessage
                  id="withdraw.stay"
                  defaultMessage="Stay in the group"
                />
              </button>
            </div>
            <div className="col-5">
              <button className="btn btn-primary" type="submit" disabled={submitting}>
                <FormattedMessage
                  id="withdraw.Confirm"
                  defaultMessage="Confirm Withdrawal"
                />
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default reduxForm({ form: 'withdrawFromPurchase' })(WithdrawFromPurchase);



// WEBPACK FOOTER //
// ./src/desktop/components/withdraw-from-purchase/index.js